import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { HeroSlider } from './components/HeroSlider';
import { CountdownBar } from './components/CountdownBar';
import { HistorySection } from './components/HistorySection';
import { FootprintSection } from './components/FootprintSection';
import { CensusSection } from './components/CensusSection';
import { CandidatesSection } from './components/CandidatesSection';
import { ActionPlanSection } from './components/ActionPlanSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MembersSection } from './components/MembersSection';
import { ClosingSection } from './components/ClosingSection';
import { SiteFooter } from './components/SiteFooter';
type AppProps = {
  candidatesLayout?: 'dosPorFila' | 'cuatroPorFila';
  /** Keep hidden until the real testimonials are delivered */
  showTestimonials?: boolean;
};
export function App({
  candidatesLayout = 'dosPorFila',
  showTestimonials = false
}: AppProps) {
  const hiddenHrefs = showTestimonials ? [] : ['#referencias'];
  return <div className="min-h-screen w-full bg-background text-foreground" data-id="element-0" data-mp="3ii4ro0w5cqo1">
      <SiteHeader hiddenHrefs={hiddenHrefs} data-id="element-1" data-mp="3mjzpuwis6nxl" />
      <main data-id="element-2" data-mp="3rcj7c4kla37o">
        <HeroSlider data-id="element-3" data-mp="3rbzn2h7gv2qh" />
        <CountdownBar data-id="element-4" data-mp="3rdkie91luppe" />
        <CandidatesSection layout={candidatesLayout} data-id="element-5" data-mp="3rd189ei755lx" />
        <CensusSection data-id="element-6" data-mp="680tswt8a8y" />
        <HistorySection data-id="element-7" data-mp="5gez9t0lqvv" />
        <FootprintSection data-id="element-8" data-mp="82j0zgp5o9c" />
        <ActionPlanSection data-id="element-9" data-mp="2zld259q0hfbj" />
        {showTestimonials && <TestimonialsSection data-id="element-10" data-mp="2zmo5x9jgin2n" />}
        <MembersSection data-id="element-11" data-mp="33mouhn09senf" />
        <ClosingSection data-id="element-12" data-mp="33m5bs42spm8c" />
      </main>
      <SiteFooter hiddenHrefs={hiddenHrefs} data-id="element-13" data-mp="33n6xd2hftr4b" />
    </div>;
}